import React, { Component } from 'react'
import { submitVote as submitVoteContract } from '../../../../contract/WagersController'
import { finalizeBet } from '../../../../api-calls/wagers'
import { Card, Popconfirm, Icon, message } from 'antd'
import { observer } from "mobx-react"
import Modal from 'react-modal'
import UserStore from '../../../../stores/UserStore';
@observer(["AuthStore", "UserStore", "TeamStore"])
export default class GetPaid extends Component {
    constructor(props) {
        super(props);
        this.state = {

            makerChoice: 0,
            payoutButton: <button className="custom-btn-primary" onClick={this.submitVote.bind(this)}>PAYOUT</button>

        };

        this.submitVote = this.submitVote.bind(this);

    }

    async componentDidMount() {
        const { TeamStore } = this.props;
        let team_one = this.props.event.teams[0];
        let team_two = this.props.event.teams[1];
        let self = this;
        // setTimeout(() => {
        //     TeamStore.teams.forEach(function (team) {
        //         if (team_one == team._id) {
        //             self.setState({

        //                 teamOneLogo: team.logoUrl,
        //                 teamOneName: team.name
        //             });
        //         }
        //         if (team_two == team._id) {
        //             self.setState({

        //                 teamTwoLogo: team.logoUrl,
        //                 teamTwoName: team.name
        //             });
        //         }
        //     });
        //     console.log("teams: " + JSON.stringify(TeamStore));
        // }
        //     , 30

        // );

    }

    submitVote() {
        const { AuthStore, UserStore } = this.props;
        let bytes32Id = this.props.bet.bytes32Id;
        let wagerId = this.props.bet._id;
        let userId = UserStore.user._id;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let winnerVote;
        let self = this;
        let eventBytes32Id = (this.props.propEvent == false ? this.props.event.bytes32Id : this.props.propEvent.bytes32Id);

        console.log("Submitting vote for bet " + this.props.bet.bytes32Id);
        this.setState({ payoutButton: <Icon style={{ fontSize: '16px', color: '#08c' }} theme="outlined" type="loading" /> });

        submitVoteContract(bytes32Id, 0).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! Bet not finalized.");
                } else {
                    return finalizeBet(
                        authToken,
                        wagerId,
                        bytes32Id,
                        eventBytes32Id
                    ).then(function () {
                        self.setState({ payoutButton: <Icon style={{ fontSize: '16px', color: '#27f727' }} theme="outlined" type="check-circle" /> });
                        return UserStore.updateUser(authToken);
                    });
                }
            });


    }


    render() {


        return (
            <div>

                {/* <Popconfirm title="Sure you want to cancel this bet?" onConfirm={this.cancelBet} okText="Yes" cancelText="No"> */}

                {this.state.payoutButton}
                {/* </Popconfirm> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/appComponents/betting/betStages/GetPaid.js